import React from 'react';
import { Card } from 'react-bootstrap';
import './LogoCard.css';

interface LogoCardProps {
  imageSrc: string;
  alt: string;
}

const LogoCard: React.FC<LogoCardProps> = ({ imageSrc, alt }) => {
  return (
    <Card className="logo-card">
      <Card.Body className="d-flex align-items-center justify-content-center">
        <img src={imageSrc} alt={alt} className="logo-image" />
      </Card.Body>
    </Card>
  );
};

export default LogoCard;
